import React from 'react';

// Styles & Assets
import styles from './CancelConfirmButtons.module.css';

// Language
import { useTranslation } from 'react-i18next';

const CancelConfirmButtons: React.FC<{
    onCancel: () => void,
    onConfirm: () => void,
    cancelName?: string
    confirmName?: string
    customStyles?: React.CSSProperties
    customButtonStyles?: React.CSSProperties
}> = ({onCancel, onConfirm, cancelName, confirmName, customStyles, customButtonStyles}) => {

    const { t } = useTranslation();

    return (
         <div className={styles.buttonsContainer} style={customStyles}>
            <button onClick={onCancel} className={`button ${styles.cancel}`} style={customButtonStyles}>
                {cancelName ?? t('cancel')}
            </button>
            <button onClick={onConfirm} className={`button ${styles.confirm}`} style={customButtonStyles}>
                {confirmName ?? t('confirm')}
            </button>
        </div>
    );
};

export default CancelConfirmButtons;